export const fileFormErrorMessages = {
  noFileSelected: "No file selected",
  fileSizeExeed: "File Size Exceeds limit - 20MB",
  incorrectType: "Only Image format is Allowed",
};

export const formSuccessMessage = {
  correctImage: "Perfect!...",
  maximumSize: "Max. Picture Size is 20MB",
};

export const landingAndResetPages = [
  "/",
  "/reset-account",
  "/report-password",
  "/reset-password",
];
